import { Model } from "@tailflow/laravel-orion/lib/model";

export class Landing extends Model<{
    parent_id: number,
    slug: string,
    description: string,
    language: string,
    blocks: object[],
    layout: string,
    layouts: string[],
    created_at: string,
    updated_at: string
}> {

    $resource(): string {
        return "module/admin/landings";
    }

}
